import type { AnnotationStroke } from './types';

/**
 * 캔버스에 스트로크 그리기
 */
export function drawStroke(
  ctx: CanvasRenderingContext2D,
  stroke: AnnotationStroke,
  canvasWidth: number,
  canvasHeight: number
) {
  if (stroke.points.length < 2) return;

  ctx.beginPath();
  ctx.strokeStyle = stroke.color;
  ctx.lineWidth = stroke.width;
  ctx.lineCap = 'round';
  ctx.lineJoin = 'round';

  // 첫 번째 포인트
  const first = stroke.points[0];
  ctx.moveTo(first.x * canvasWidth, first.y * canvasHeight);

  // 베지어 곡선으로 부드럽게 연결
  if (stroke.points.length === 2) {
    const second = stroke.points[1];
    ctx.lineTo(second.x * canvasWidth, second.y * canvasHeight);
  } else {
    for (let i = 1; i < stroke.points.length - 1; i++) {
      const current = stroke.points[i];
      const next = stroke.points[i + 1];

      const currentX = current.x * canvasWidth;
      const currentY = current.y * canvasHeight;
      const nextX = next.x * canvasWidth;
      const nextY = next.y * canvasHeight;

      // 중점을 제어점으로 사용하여 부드러운 곡선
      const midX = (currentX + nextX) / 2;
      const midY = (currentY + nextY) / 2;

      ctx.quadraticCurveTo(currentX, currentY, midX, midY);
    }

    // 마지막 포인트
    const last = stroke.points[stroke.points.length - 1];
    ctx.lineTo(last.x * canvasWidth, last.y * canvasHeight);
  }

  ctx.stroke();
}

/**
 * 특정 위치에서 스트로크 찾기 (지우개용)
 */
export function findStrokeAtPoint(
  x: number,
  y: number,
  strokes: AnnotationStroke[],
  canvasSize: { width: number; height: number }
): AnnotationStroke | null {
  const threshold = 10; // 픽셀 허용 오차

  // 뒤에서부터 검색 (최근 그린 것 우선)
  for (let i = strokes.length - 1; i >= 0; i--) {
    const stroke = strokes[i];

    for (const point of stroke.points) {
      const px = point.x * canvasSize.width;
      const py = point.y * canvasSize.height;

      const distance = Math.sqrt((px - x) ** 2 + (py - y) ** 2);
      if (distance < threshold + stroke.width / 2) {
        return stroke;
      }
    }
  }

  return null;
}
